import PropTypes from "prop-types"
import React from "react"

import ClickablePhoneNumber from "src/components/ClickablePhoneNumber"

const ContactSection = ({ contact }) => {
  const { name, email, phone, url } = contact

  const items = [
    email && <span>{email}</span>,
    phone && <ClickablePhoneNumber phone={phone} displayPhone={phone} />,
  ].filter(Boolean)

  return (
    <div>
      <h2 className="m-0 text-xxs uppercase tracking-wide text-gray-500">
        Customer
      </h2>
      <div className="mt-1 space-y-1">
        <div>
          <a className="font-semibold text-blue-600 hover:underline" href={url}>
            {name}
          </a>
        </div>
        <div className="flex flex-wrap items-center gap-x-2 text-sm">
          {items.map((item, i) => (
            <React.Fragment key={i}>
              {i > 0 && <span aria-hidden="true">·</span>}
              {item}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

ContactSection.propTypes = {
  contact: PropTypes.shape({
    name: PropTypes.string.isRequired,
    email: PropTypes.string,
    phone: PropTypes.string,
    url: PropTypes.string.isRequired,
  }).isRequired,
}

export default ContactSection
